import Select, { components, InputActionMeta, MultiValue, MultiValueGenericProps, OptionProps } from 'react-select';
import './styles.scss';
import { Typography } from 'Components/atoms';
import { ReactNode } from 'react';
import { SourceTone } from 'Components/atoms/SourcePill/SourcePill';

export interface OptionType {
    value: string;
    label: string;
    icon?: string;
    iconNode?: ReactNode;
    tone?: SourceTone;
}

interface ChipMultiSelectProps {
    id: string;
    selected: OptionType[];
    onChange: (newValue: MultiValue<OptionType>) => void;
    placeholder: ReactNode | string;
    options: OptionType[];
    onInputChange?: ((newValue: string, actionMeta: InputActionMeta) => void) | undefined;
}

const renderOptionIcon = (data: OptionType) => {
    if (data.iconNode) {
        return <span className="bootstrap-select__multi-value-icon-node">{data.iconNode}</span>;
    }
    if (data.icon) {
        return <img src={data.icon} alt="" className="bootstrap-select__multi-value-label" />;
    }
    return null;
};

const MultiValueLabel = (props: MultiValueGenericProps<OptionType>) => {
    return (
        <components.MultiValueLabel {...props}>
            {renderOptionIcon(props.data)}
            {props.data.label}
        </components.MultiValueLabel>
    );
};

const CustomOption = (props: OptionProps<OptionType>) => {
    const { data, innerRef, innerProps } = props;
    return (
        <div ref={innerRef} {...innerProps} className="bootstrap-select__custom-option d-flex align-items-center">
            {renderOptionIcon(data)}
            <Typography variant={'caption1'} className="mb-0">
                {data.label}
            </Typography>
        </div>
    );
};

const ChipMultiSelect = ({ id, placeholder, selected, options, onChange, onInputChange }: ChipMultiSelectProps) => {
    return (
        <div className="container w-100 ps-2">
            <Select
                id={id}
                options={Array.isArray(options) ? options : []}
                className="bootstrap-select"
                classNamePrefix="select"
                placeholder={placeholder}
                onChange={onChange}
                value={selected}
                isMulti
                components={{ MultiValueLabel, Option: CustomOption }}
                onInputChange={onInputChange}
            />
        </div>
    );
};

export default ChipMultiSelect;
